import { ChannelMember } from '../../models/channels/types';
import DEFAULT_AVATAR_NEW from '../../models/advocate/avatar';

export interface Follower {
  id: number;
  avatarUrl: string;
  avatarColor: string;
  name: string;
}

export function mapMember(item: ChannelMember): Follower {
  return {
    id: parseInt(item.id, 10),
    avatarUrl: item.attributes.avatar.url || DEFAULT_AVATAR_NEW,
    avatarColor: item.attributes.avatar.color,
    name: item.attributes.name,
  };
}
